module.exports = __webpack_public_path__ + "img/seal.cf24fe6f.png";